<template>
  <div class="window-height">
    <q-inner-loading showing color="secondary" />
  </div>
</template>

<script lang="ts">
import { LocalStorage } from 'quasar'

export default {
  mounted() {
    const queryError = this.$route.query.error
    const error =
      queryError === 'access_denied' ||
      queryError === 'unauthorized' ||
      queryError === 'invalid_request'

    const loginRedirectTo = LocalStorage.getItem<string>('loginRedirectTo')
    LocalStorage.removeItem('loginRedirectTo')

    // Post-login deny (e.g. personal email via Google SSO) lands here with an error and no
    // session. Send users to a terminal page so authBeforeEnter doesn't loginWithRedirect again.
    if (error) {
      this.$router.replace('/work-email-required')
    } else {
      this.$router.push(loginRedirectTo ?? '/')
    }
  }
}
</script>
